import React, { useState, useEffect } from "react";

import { Route, Routes, BrowserRouter, useLocation } from "react-router-dom";
import GalleryPage from "../pages/GalleryPage";
import AboutPage from "../pages/AboutPage";
import Backbone from "./Backbone";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

function CentralRoute() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Backbone />}>
                    <Route index element={<GalleryPage language={"gr"} />} />
                    <Route path="about" element={<AboutPage language={"gr"} />} />
                </Route>
                <Route path="/en/" element={<Backbone />}>
                    <Route index element={<GalleryPage language={"en"} />} />
                    <Route path="about" element={<AboutPage language={"en"} />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default CentralRoute;